import OwnableTheme from '@Theme';
import { useDimensions } from '@react-native-community/hooks';
import { observer } from 'mobx-react-lite';
import { StyleSheet, Text, View } from 'react-native';

export const LoadingScreen = observer(function LoadingScreen() {
  const {
    window: { width, height },
  } = useDimensions();

  return (
    <View style={[styles.wrapper, { width, height }]}>
      <Text style={styles.message}>Loading...</Text>
    </View>
  );
});

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  message: {
    fontSize: 16,
    color: OwnableTheme.colors.black,
  },
});
